<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<bread-crumbs
			:title="$t('ListVisitPoint')"
			:subTitle="$t('general.SubtitleVisitPoint2')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<vx-card>
			<visit-point-list
				v-if="visitpointReadPermission"
				class="mt-4"
				:massiveDeletePermission="massiveDeletePermission"
			/>
			<not-permission v-else :message="message"></not-permission>
		</vx-card>
	</div>
</template>

<script>
import VisitPointList from "./VisitPointList.vue";
import User from "@/models/User.js";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		VisitPointList,
		NotPermission,
	},
	data() {
		return {
			activeTab: 0,
			userSession: new User(),
			permissions: [],
			role: "",
		};
	},
	computed: {
		massiveDeletePermission() {
			const che = this.$store.getters.checkPermission("VISIT_POINT_VPMD");
			return che;
		},
		visitpointReadPermission() {
			return this.$store.getters.checkPermission("VISIT_POINT_R");
		},
		message() {
			return `${this.$t("Permissions.RequiredPermissions")} "VISIT_POINT_R"`;
		},
	},
	methods: {
		async getPermissions() {
			const user = await this.userSession.getUser();
			this.permissions = user.permissions;
			this.role = user.role_name;
		},
	},
	created() {
		this.getPermissions();
	},
};
</script>
